import { render, staticRenderFns } from "./PurchasePlanPage.vue?vue&type=template&id=60938291&"
import script from "./PurchasePlanPage.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports